import { Button } from 'react-bootstrap';
import styled from 'styled-components';

const Link = styled(Button).attrs(() => ({
    bsStyle: 'link'
}))`
    text-transform: uppercase;
    margin: 0 10px;
    padding: 0px 20px;
    font-size: 14px;
    height: 48px;
`;

export const NoPaddingLink = styled(Button).attrs(() => ({
    bsStyle: 'link'
}))`
    text-transform: uppercase;
    margin: 0;
    padding: 0;
    font-size: 14px;
`;

export default Link;



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/standard/Link.js